export default function xorEncrypt(str, key) {
  // eslint-disable-next-line no-bitwise
  return Array.from(str).map((char, i) => (char.charCodeAt(0) ^ key.charCodeAt(i % key.length)).toString(16).padStart(2, '0')).join('')
}
